import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import AxiosService from "../services/axios.service";
import Multiselect from 'multiselect-react-dropdown';


const GOOGLE_MAP_API_KEY = "AIzaSyA8oEXVIh8RoYuGQO-J0-iMEAL0wQGYSU8";
const API_PATH = "attorneys";

const loadGoogleMapScript = (callback) => {
    if (
        typeof window.google === "object" &&
        typeof window.google.maps === "object"
    ) {
        callback();
    } else {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
        window.document.body.appendChild(googleMapScript);
        googleMapScript.addEventListener("load", callback);
    }
};

function AddEditAtt({ history, match }) {

    const placeInputRef = useRef(null);
    const { id } = match.params;
    const isAddMode = !id;
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState([]);
    const [courts, setCourts] = useState([]);
    const [address, setAddress] = useState("");

    function onSelect(selectedList, selectedItem) {
        setCourts(selectedList);
    }

    function onRemove(selectedList, removedItem) {
        setCourts(selectedList);
    }

    // form validation rules 
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        phone: Yup.string(),
        email: Yup.string().email(),
        street_address: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        zip: Yup.string(),
        organizations: Yup.string(),
        admitted: Yup.string(),
        practice_area: Yup.string(),
        month_year_joined: Yup.string(),
        referred: Yup.string(),
        longitude: Yup.string(),
        latitude: Yup.string()
    });

    // functions to build form returned by useForm() hook
    const { register, watch, handleSubmit, reset, setValue, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {

        var appellate_courts = [];
        for (var i in courts) {
            var court = new Object();
            court.name = courts[i].name;
            court.abbreviation = courts[i].abbreviation;
            appellate_courts.push(court);
        }
        console.log(JSON.stringify(appellate_courts));
        data.courts = appellate_courts;

        /*data.street_address
        data.city
        data.state*/
        return isAddMode
            ? createAttorney(data)
            : updateAttorney(id, data);
    }

    function createAttorney(data) {
        console.log(data);
        return AxiosService.create(API_PATH, data)
            .then(() => {
                console.log(JSON.stringify(data));
                history.push('.');
            })
    }

    function updateAttorney(id, data) {
        return AxiosService.update(API_PATH, id, data)
            .then(() => {
                console.log(JSON.stringify(data));
                history.push('..');
            })
    }


    useEffect(() => {
        AxiosService.getAll("courts").then(x => {
            setOptions(x.data)
        }
        );

        register("address");
        register("street_address");
        register("city");
        register("state");
        register("zip");
        register("latitude");
        register("longitude");

        loadGoogleMapScript(() => {
            initPlaceAPI();
        });

        if (!isAddMode) {
            // get user and set form fields
            AxiosService.get(API_PATH, id).then(x => {
                var attorney = x.data;
                setCourts(attorney.courts);
                setSelectedValue(attorney.courts);
                const fields = ['name', 'phone', 'email', 'street_address', 'city', 'state', 'zip', 'courts', 'admitted', 'practice_area', 'month_year_joined', 'latitude', 'longitude'];
                fields.forEach(field => setValue(field, attorney[field]));
                //setAddress(watch("street_address") + watch("city") + watch("state"));
                setAddress(attorney.street_address + ", " + attorney.city + ", " + attorney.state);
                //setValue("phone", 1 + watch("phone"));
                //setValue("address", watch("street_address") + ", " + watch("city") + ", " + watch("state") + " " + watch("zip"));
            })
        }
    }, []);

    function handleChange(event) {
        console.log("kekker " + event.target.value);
        setAddress(event.target.value);
    }

    const onFocus = event => {
        if (event.target.autocomplete) {
            event.target.autocomplete = "whatever";
        }
    };

    function selectAddress(place) {
        console.log(place.formatted_address);
        var address_fields = place.formatted_address.split(",");

        setValue("street_address", address_fields[0]);
        setValue("city", address_fields[1]);
        setValue("state", address_fields[2]);
        setValue("zip", address_fields[3]);
        setValue("latitude", place.geometry.location.lat());
        setValue("longitude", place.geometry.location.lng());
    }

    const initPlaceAPI = () => {
        let autocomplete = new window.google.maps.places.Autocomplete(
            placeInputRef.current
        );
        new window.google.maps.event.addListener(
            autocomplete,
            "place_changed",
            function () {
                selectAddress(autocomplete.getPlace());
            }
        );
    };
    // AUTOCOMPLETE is disabled on all except fields like practicearea.
    return (
        <div>

            <form onFocus={onFocus} onSubmit={handleSubmit(onSubmit)} onReset={reset}>
                <h1>{isAddMode ? 'Add Attorney' : 'Edit Attorney'}</h1>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Name</label>
                        <input name="name" autoComplete="off" type="text" ref={register} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.name?.message}</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Appellate Courts</label>
                        <Multiselect
                            options={options} // Options to display in the dropdown
                            selectedValues={selectedValue} // Preselected value to persist in dropdown
                            onSelect={onSelect} // Function will trigger on select event
                            onRemove={onRemove} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            closeOnSelect={true}
                            avoidHighlightFirstOption="true"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Phone</label>
                        <input name="phone" autoComplete="off" type="text" ref={register} className={`form-control ${errors.phone ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.phone?.message}</div>
                    </div>
                </div>
                {/* <div className="form-row">
                    <div className="form-group col-5">
                        <label>Phone Number</label>
                        <PhoneInput
                            autoComplete="off"
                            placeholder="Enter phone number"
                            name="phone"
                            type="text"
                            ref={register("phone")}
                            onChange={phone => setValue("phone", phone)}
                            country={'us'}
                            value={watch("phone")}
                        />
                    </div>
                </div> */}

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Email</label>
                        <input autoComplete="off" name="email" type="text" ref={register} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.case_id?.message}</div>

                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Address</label>
                        <input autoComplete="new-password" id="address" name="address" type="text" value={address} onChange={handleChange} ref={placeInputRef} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.case_name?.message}</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Practice Area</label>
                        <input name="practice_area" type="text" ref={register} className={`form-control ${errors.practice_area ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.staff_member?.message}</div>

                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Month/Year Admitted</label>
                        <input autoComplete="off" name="admitted" type="text" ref={register} className={`form-control ${errors.admitted ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.staff_member?.message}</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-5">
                        <label>Month/Year Joined</label>
                        <input autoComplete="off" name="month_year_joined" type="text" ref={register} className={`form-control ${errors.staff_member ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.staff_member?.message}</div>
                    </div>
                </div>

                {/* deadline date picker */}

                <div className="form-group">
                    <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                        {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                        Save
                    </button>
                    <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
                    {/* <map /> */}


                </div>
            </form >
        </div>
    );
}

export { AddEditAtt };